export const statusDispatch = {
    PENDING_PICKING: 'Pendiente de Picking',
    PENDING_DISPATCH: 'Pendiente de Despacho',
    PENDING_RECEPTION: 'Pendiente de Recepcion',
    PENDING_CUSTOMER_DISPATCH: 'Pendiente de Despacho Cliente',
    PENDING_RECEPTION_PROVIDER: 'Pendiente de Recojo Proveedor',
    CANCELLED: 'Cancelado',
    RETURNED: 'En Devolución',
    PENDING_RETURNED_ORIGIN: 'En Devolución a Origen',
    RETURNED_ORIGIN: 'Devuelto a Origen',
    PENDING_CUSTOMER_COLLECT: 'Pendiente de Recojo Cliente',
    DELIVERED: 'Entregado'
  };
  